/* ============================================================
   MURENZO THEME - JavaScript
   ============================================================ */

(function() {
  'use strict';

  /* ---------- Announcement Bar Slider ---------- */
  function initAnnouncementBar() {
    var slides = document.querySelectorAll('.announcement-bar__slide');
    if (!slides.length) return;

    var currentIndex = 0;
    var total = slides.length;

    function showSlide(idx) {
      slides.forEach(function(s) { s.classList.remove('is-active'); });
      slides[idx].classList.add('is-active');
      currentIndex = idx;
    }

    var prevBtn = document.getElementById('ann-prev');
    var nextBtn = document.getElementById('ann-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        showSlide((currentIndex - 1 + total) % total);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        showSlide((currentIndex + 1) % total);
      });
    }

    // Auto-rotate every 4 seconds
    if (total > 1) {
      setInterval(function() {
        showSlide((currentIndex + 1) % total);
      }, 4000);
    }
  }

  /* ---------- Mobile Menu ---------- */
  function initMobileMenu() {
    var toggle = document.getElementById('mobile-menu-toggle');
    var menu = document.getElementById('mobile-menu');
    if (!toggle || !menu) return;

    var isOpen = false;

    function openMenu() {
      isOpen = true;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      isOpen = false;
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function() {
      isOpen ? closeMenu() : openMenu();
    });

    // Close button (×)
    var closeBtn = document.getElementById('mobile-menu-close');
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    // Close on overlay click
    var overlay = document.getElementById('mobile-menu-overlay');
    if (overlay) overlay.addEventListener('click', closeMenu);

    // Close on click outside
    document.addEventListener('click', function(e) {
      if (isOpen && !menu.contains(e.target) && e.target !== toggle && !toggle.contains(e.target)) {
        closeMenu();
      }
    });

    // Close on ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) closeMenu();
    });
  }

  /* ---------- Search Drawer ---------- */
  function initSearchDrawer() {
    var toggle = document.getElementById('search-toggle');
    var drawer = document.getElementById('search-drawer');
    var overlay = drawer ? drawer.querySelector('.search-drawer__overlay') : null;
    var closeBtn = document.getElementById('search-drawer-close');
    var input = drawer ? drawer.querySelector('.search-drawer__input') : null;
    if (!toggle || !drawer) return;

    function openSearch() {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (input) setTimeout(function() { input.focus(); }, 300);
    }

    function closeSearch() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', openSearch);
    if (overlay) overlay.addEventListener('click', closeSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeSearch();
    });
  }

  /* ---------- Cart Popup ---------- */
  function initCartDrawer() {
    var popup    = document.getElementById('cart-popup');
    var overlay  = document.getElementById('cart-popup-overlay');
    var closeBtn = document.getElementById('cart-popup-close');
    var cartToggle = document.getElementById('cart-toggle');
    if (!popup) return;

    function openCart() {
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      fetchCart();
    }

    function closeCart() {
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (cartToggle) cartToggle.addEventListener('click', function(e) { e.preventDefault(); openCart(); });
    if (overlay)  overlay.addEventListener('click', closeCart);
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') closeCart();
    });
    document.addEventListener('cart:updated', openCart);
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  function renderCart(cart) {
    var body    = document.getElementById('cart-drawer-body');
    var footer  = document.getElementById('cart-drawer-footer');
    var countEl = document.getElementById('cart-count');

    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.classList.toggle('visually-hidden', cart.item_count === 0);
    }
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-popup__empty">YOUR CART IS EMPTY</p>' +
        '<a href="/collections/all" class="button button--primary" style="display:block;margin-top:16px">DISCOVER OUR COLLECTION</a>';
      if (footer) footer.style.display = 'none';
      var slot = document.getElementById('cart-recs-slot');
      if (slot) slot.innerHTML = '';
      var dline = document.getElementById('cart-discount-line');
      if (dline) { dline.style.display = 'none'; dline.innerHTML = ''; }
      return;
    }

    var itemsHtml = cart.items.map(function(item) {
      // Parse options from variant_title "Color / Size" or use options_with_values
      var optionsHtml = '';
      if (item.options_with_values) {
        optionsHtml = item.options_with_values.map(function(opt) {
          return '<span class="cart-item__option">' + escapeHtml(opt.name) + ': ' + escapeHtml(opt.value) + '</span>';
        }).join('');
      } else if (item.variant_title && item.variant_title !== 'Default Title') {
        optionsHtml = '<span class="cart-item__option">' + escapeHtml(item.variant_title) + '</span>';
      }

      var imgSrc = item.featured_image ? item.featured_image.url : (item.image || '');

      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<div class="cart-item__img-wrap">' +
          (imgSrc ? '<img class="cart-item__image" src="' + imgSrc + '" alt="' + escapeHtml(item.title) + '">' : '') +
        '</div>' +
        '<div class="cart-item__details">' +
          '<div class="cart-item__head">' +
            '<p class="cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
            '<span class="cart-item__line-price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<p class="cart-item__unit-price">' + formatMoney(item.final_price) + '</p>' +
          '<div class="cart-item__options">' + optionsHtml + '</div>' +
          '<div class="cart-item__bottom">' +
            '<div class="cart-item__qty-wrap">' +
              '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
              '<span class="cart-item__qty">' + item.quantity + '</span>' +
              '<button class="cart-item__qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<button class="cart-item__delete" data-key="' + item.key + '" aria-label="Remove item">' +
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M2 4h12M6 4V2h4v2M13 4l-1 10H4L3 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    body.innerHTML = '<div class="cart-items">' + itemsHtml + '</div>';

    if (footer) {
      footer.style.display = 'block';
      var subtotalEl = document.getElementById('cart-subtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }

    // Discount line
    renderDiscountLine(cart);

    // Qty buttons
    body.querySelectorAll('.cart-item__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.getAttribute('data-key');
        var qty = parseInt(this.getAttribute('data-qty'), 10);
        updateCartItem(key, Math.max(0, qty));
      });
    });

    // Delete buttons
    body.querySelectorAll('.cart-item__delete').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(this.getAttribute('data-key'), 0);
      });
    });
  }

  function renderDiscountLine(cart) {
    var line = document.getElementById('cart-discount-line');
    if (!line) return;
    var discount = cart.total_discount || 0;
    var discounts = cart.cart_level_discount_applications || [];

    if (discount > 0 && discounts.length > 0) {
      var d = discounts[0];
      var title = d.title || 'Discount';
      line.style.display = 'flex';
      line.innerHTML =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>' +
          '<line x1="7" y1="7" x2="7.01" y2="7"/>' +
        '</svg>' +
        '<span class="cart-discount-line__text">' + escapeHtml(title) + '</span>' +
        '<span class="cart-discount-line__amount">-' + formatMoney(discount) + '</span>';
    } else {
      line.style.display = 'none';
      line.innerHTML = '';
    }
  }

  function renderCartRecs(cart) {
    var slot = document.getElementById('cart-recs-slot');
    if (!slot) return;

    if (!cart.items || cart.items.length === 0) {
      slot.innerHTML = '';
      return;
    }

    var firstItem = cart.items[0];
    var cartProductIds = cart.items.map(function(i) { return i.product_id; });

    fetch('/recommendations/products.json?product_id=' + firstItem.product_id + '&limit=10&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.products || []).filter(function(p) {
          return cartProductIds.indexOf(p.id) === -1;
        }).slice(0, 6);

        if (products.length === 0) { slot.innerHTML = ''; return; }

        var cardsHtml = products.map(function(p) {
          var img = p.featured_image ? p.featured_image : (p.images && p.images[0] ? p.images[0] : '');
          var imgUrl = '';
          if (typeof img === 'string') imgUrl = img;
          else if (img && img.src) imgUrl = img.src;
          if (imgUrl && imgUrl.indexOf('?') === -1) imgUrl = imgUrl + '?width=300';

          var price = (p.price !== undefined) ? p.price :
                      (p.variants && p.variants[0] ? p.variants[0].price : 0);
          var compare = (p.compare_at_price !== undefined) ? p.compare_at_price :
                        (p.variants && p.variants[0] ? p.variants[0].compare_at_price : 0);

          var firstVariant = p.variants && p.variants[0] ? p.variants[0] : null;
          var variantId = firstVariant ? firstVariant.id : '';
          var hasMultipleVariants = p.variants && p.variants.length > 1;

          var priceHtml = '<span class="cart-rec-card__price">' + formatMoney(price) + '</span>';
          if (compare && compare > price) {
            priceHtml += '<span class="cart-rec-card__compare">' + formatMoney(compare) + '</span>';
          }

          var url = '/products/' + p.handle;
          var btnHtml;
          if (hasMultipleVariants) {
            btnHtml = '<a href="' + url + '" class="cart-rec-card__btn">VIEW</a>';
          } else {
            btnHtml = '<button type="button" class="cart-rec-card__btn cart-rec-card__btn--add" data-rec-add="' + variantId + '">+ ADD</button>';
          }

          return '<div class="cart-rec-card">' +
            '<a href="' + url + '" class="cart-rec-card__img-link">' +
              '<div class="cart-rec-card__img-wrap">' +
                (imgUrl ? '<img class="cart-rec-card__img" src="' + imgUrl + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
              '</div>' +
            '</a>' +
            '<div class="cart-rec-card__info">' +
              '<a href="' + url + '" class="cart-rec-card__name-link"><div class="cart-rec-card__name">' + escapeHtml(p.title).toUpperCase() + '</div></a>' +
              '<div class="cart-rec-card__price-row">' + priceHtml + '</div>' +
              btnHtml +
            '</div>' +
          '</div>';
        }).join('');

        slot.innerHTML =
          '<div class="cart-recs">' +
            '<div class="cart-recs__title">YOU MAY ALSO LIKE</div>' +
            '<div class="cart-recs__row">' + cardsHtml + '</div>' +
          '</div>';

        // Quick-add handlers
        slot.querySelectorAll('[data-rec-add]').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var id = this.getAttribute('data-rec-add');
            if (!id) return;
            var origText = this.textContent;
            this.disabled = true;
            this.textContent = '...';
            var that = this;
            fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: parseInt(id), quantity: 1 })
            })
            .then(function(r) { return r.json().then(function(b) { return { ok: r.ok, body: b }; }); })
            .then(function(res) {
              if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add');
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              renderCart(cart);
            })
            .catch(function(err) {
              that.disabled = false;
              that.textContent = origText;
              alert(err.message || 'Could not add. Try opening the product.');
            });
          });
        });
      })
      .catch(function() { slot.innerHTML = ''; });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCart(cart); })
    .catch(function(err) { console.error('Cart update error:', err); });
  }

  function formatMoney(value) {
    // Shopify cart.js + /products/x.js + /recommendations/products.json return integer cents.
    var cents = parseInt(value, 10);
    if (isNaN(cents)) cents = 0;
    return 'LE ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Add to Cart ---------- */
  function performAddToCart(form, submitBtn) {
    if (!form) return;
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'ADDING...'; }

    var formData = new FormData(form);
    console.log('[AddToCart] POST /cart/add.js');

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: formData
    })
    .then(function(r) {
      return r.json().then(function(body) { return { ok: r.ok, status: r.status, body: body }; });
    })
    .then(function(res) {
      console.log('[AddToCart] Response:', res.status, res.body);
      if (!res.ok) {
        throw new Error(
          (res.body && (res.body.description || res.body.message)) ||
          'Error ' + res.status + ' adding to cart'
        );
      }
      if (submitBtn) submitBtn.textContent = 'ADDED!';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      var popup = document.getElementById('cart-popup');
      if (popup) {
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      fetchCart();
      setTimeout(function() {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
      }, 2000);
    })
    .catch(function(err) {
      console.error('[AddToCart] Failed:', err);
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
      alert(err.message || 'Error adding to cart. Please try again.');
    });
  }

  function isProductForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    return form.classList.contains('product-form') ||
           form.getAttribute('data-type') === 'add-to-cart-form' ||
           (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1);
  }

  /* ---------- Checkout button safety net ---------- */
  function initCheckoutButton() {
    // Force any cart popup checkout link to navigate to /checkout, even if
    // some other script tries to intercept or rewrite it.
    document.addEventListener('click', function(e) {
      var link = e.target.closest && e.target.closest('.cart-popup__checkout');
      if (!link) return;
      // Stop other handlers, then navigate explicitly
      e.preventDefault();
      e.stopImmediatePropagation();
      console.log('[Checkout] Navigating to /checkout');
      window.location.href = '/checkout';
    }, true);
  }

  function initAddToCart() {
    // Layer 1: capture-phase submit listener (catches before any other handler)
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!isProductForm(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      console.log('[AddToCart] Submit intercepted', form);
      var btn = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
      if (btn && btn.disabled) return;
      performAddToCart(form, btn);
    }, true);

    // Layer 2: click on the submit button itself (in case form submit is bypassed)
    document.addEventListener('click', function(e) {
      var btn = e.target.closest && e.target.closest('button[name="add"], .product-form__submit');
      if (!btn) return;
      var form = btn.closest('form');
      if (!isProductForm(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      console.log('[AddToCart] Button click intercepted', btn);
      if (btn.disabled) return;
      performAddToCart(form, btn);
    }, true);
  }

  /* ---------- Sticky Header Shadow ---------- */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = '';
      }
    }, { passive: true });
  }

  /* ── Bundle Cards ── */
  function initBundleCards() {
    var section = document.querySelector('.bundle-options');
    if (!section) return;

    var variants = window.productBundleVariants || [];
    var colorIdx = (window.bundleColorIdx !== undefined) ? window.bundleColorIdx : -1;
    var sizeIdx  = (window.bundleSizeIdx  !== undefined) ? window.bundleSizeIdx  : -1;

    var activeBundleType = 'duo';

    var cards = section.querySelectorAll('.bundle-card');
    cards.forEach(function(card) {
      var bundleVal = card.getAttribute('data-bundle');
      if (bundleVal === 'duo') card.classList.add('is-active');

      card.addEventListener('click', function(e) {
        // Don't switch bundle if user is interacting with a select
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
        activeBundleType = bundleVal;
        cards.forEach(function(c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
        updateSubmitBtn();
      });
    });

    // Stop selects from triggering card click
    section.querySelectorAll('.bundle-card__select').forEach(function(sel) {
      sel.addEventListener('click', function(e) { e.stopPropagation(); });
      sel.addEventListener('mousedown', function(e) { e.stopPropagation(); });
      sel.addEventListener('touchstart', function(e) { e.stopPropagation(); }, { passive: true });
    });

    function updateSubmitBtn() {
      var btn = document.getElementById('bundle-submit-btn');
      if (!btn) return;
      btn.textContent = activeBundleType === 'trio'
        ? 'Add Trio to Cart — Save 100 EGP + Free Shipping 🚚'
        : 'Add Duo to Cart — Save 100 EGP 🔥';
    }
    updateSubmitBtn();

    function findVariant(colorVal, sizeVal) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var cOk = colorIdx < 0 || v.options[colorIdx] === colorVal;
        var sOk = sizeIdx  < 0 || v.options[sizeIdx]  === sizeVal;
        if (cOk && sOk && v.available) return v;
      }
      // No available variant matching — return first match (even if unavailable) so we can show a clear error
      for (var j = 0; j < variants.length; j++) {
        var vv = variants[j];
        var cOk2 = colorIdx < 0 || vv.options[colorIdx] === colorVal;
        var sOk2 = sizeIdx  < 0 || vv.options[sizeIdx]  === sizeVal;
        if (cOk2 && sOk2) return vv;
      }
      return null;
    }

    var submitBtn = document.getElementById('bundle-submit-btn');
    if (!submitBtn) return;

    submitBtn.addEventListener('click', function() {
      var maxRows = activeBundleType === 'trio' ? 3 : 2;

      // Resolve each row to a variant, validate up front
      var resolved = [];
      for (var r = 1; r <= maxRows; r++) {
        var colorSel = section.querySelector('[data-type="color"][data-bundle="' + activeBundleType + '"][data-row="' + r + '"]');
        var sizeSel  = section.querySelector('[data-type="size"][data-bundle="'  + activeBundleType + '"][data-row="' + r + '"]');
        var colorVal = colorSel ? colorSel.value : null;
        var sizeVal  = sizeSel  ? sizeSel.value  : null;
        var v = findVariant(colorVal, sizeVal);
        var label = [colorVal, sizeVal].filter(Boolean).join(' / ');
        if (!v) {
          alert('Row #' + r + ': No matching variant for ' + label);
          return;
        }
        if (!v.available) {
          alert('Row #' + r + ': "' + label + '" is sold out. Please choose another option.');
          return;
        }
        resolved.push({ id: v.id, quantity: 1, label: label });
      }

      console.log('[Bundle] Adding', activeBundleType, resolved);

      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';

      // Sequential add — most reliable across all variant combos
      var idx = 0;
      var added = 0;
      var firstError = null;

      function finish() {
        // Verify cart actually has the items
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            console.log('[Bundle] Cart after add:', cart);
            submitBtn.disabled = false;
            updateSubmitBtn();

            if (added === 0) {
              alert(firstError || 'Could not add bundle. Please try different options.');
              return;
            }

            submitBtn.textContent = '✓ Added to Cart!';
            setTimeout(function() { updateSubmitBtn(); }, 1500);

            // Open cart popup with fresh cart data
            var popup = document.getElementById('cart-popup');
            if (popup) {
              popup.setAttribute('aria-hidden', 'false');
              document.body.style.overflow = 'hidden';
            }
            renderCart(cart);

            if (added < resolved.length && firstError) {
              setTimeout(function() {
                alert('Only ' + added + ' of ' + resolved.length + ' items were added. ' + firstError);
              }, 200);
            }
          })
          .catch(function(err) {
            console.error('[Bundle] Cart verify error:', err);
            submitBtn.disabled = false;
            updateSubmitBtn();
            alert('Add succeeded but could not refresh cart. Please refresh the page.');
          });
      }

      function addNext() {
        if (idx >= resolved.length) { finish(); return; }
        var item = resolved[idx];
        console.log('[Bundle] POST item', idx + 1, 'of', resolved.length, ':', item);

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.id, quantity: 1 })
        })
        .then(function(r) {
          return r.json().then(function(body) { return { ok: r.ok, status: r.status, body: body }; });
        })
        .then(function(res) {
          if (res.ok) {
            added++;
            console.log('[Bundle] ✓ Added', item.label, res.body);
          } else {
            console.warn('[Bundle] ✗ Failed', item.label, res.status, res.body);
            if (!firstError) {
              firstError = (res.body && (res.body.description || res.body.message)) || ('Item unavailable: ' + item.label);
            }
          }
          idx++;
          addNext();
        })
        .catch(function(err) {
          console.error('[Bundle] Network error:', err);
          if (!firstError) firstError = 'Network error: ' + err.message;
          idx++;
          addNext();
        });
      }

      addNext();
    });
  }

  /* ── Sticky Add to Cart bar (mobile) ── */
  function initStickyAddBar() {
    var bar = document.getElementById('product-sticky-bar');
    if (!bar) return;
    var realBtn = document.querySelector('.product-form__submit');
    var stickyBtn = document.getElementById('sticky-add-btn');
    if (!realBtn || !stickyBtn) return;

    // Click forwards to Shopify's Buy it now button (keeps the selected variant and quantity)
    stickyBtn.addEventListener('click', function() {
      var buyBtn = document.querySelector('.product-form__dynamic-checkout .shopify-payment-button__button');
      if (buyBtn) {
        buyBtn.click();
        return;
      }
      // Fallback if the button hasn't rendered: go straight to checkout
      var form = realBtn.closest('form');
      var idInput = form && form.querySelector('[name="id"]');
      var qtyInput = form && form.querySelector('[name="quantity"]');
      if (!idInput) return;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      window.location.href = '/cart/' + idInput.value + ':' + qty;
    });

    // Mirror disabled state and label
    function syncBtn() {
      var disabled = realBtn.disabled;
      stickyBtn.disabled = disabled;
      stickyBtn.textContent = disabled ? 'SOLD OUT' : 'BUY IT NOW';
    }
    syncBtn();
    var mo = new MutationObserver(syncBtn);
    mo.observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });

    // Show bar only when the real button is out of view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          } else {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          }
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      io.observe(realBtn);
    } else {
      // Fallback: show after scrolling 400px
      window.addEventListener('scroll', function() {
        var show = window.scrollY > 400;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { passive: true });
    }

    // Mirror price when variant changes (variant change updates the main price element)
    var priceEl = document.getElementById('product-price');
    var stickyPriceEl = document.getElementById('sticky-bar-price');
    if (priceEl && stickyPriceEl) {
      var priceMo = new MutationObserver(function() {
        stickyPriceEl.textContent = priceEl.textContent;
      });
      priceMo.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAnnouncementBar();
    initMobileMenu();
    initSearchDrawer();
    initCartDrawer();
    initAddToCart();
    initCheckoutButton();
    initStickyHeader();
    initBundleCards();
    initStickyAddBar();
  });

})();
